export const AddressesDB = [
  {
    id: 1,
    name: "Rishabh",
    address: "#246, Epitome Colony",
    city: "Jalandhar",
    state: "Punjab",
    country: "India",
    zip: 152001,
    mob: 9877651233
  },
  {
    id: 2,
    name: "Draven",
    address: "#256, Epitome Colony",
    city: "Ludhiana",
    state: "Punjab",
    country: "India",
    zip: 152004,
    mob: 9807865672
  }
];
